module.exports = __webpack_public_path__ + "media/tray_selector/baseline-refresh-24px-dac3e09c.svg";